import React from "react";
import { PrismicPreviewProvider } from "gatsby-plugin-prismic-previews";
import { ThemeProvider } from "styled-components";

import BreakpointsProvider from "components/shared/BreakpointsProvider";
import theme from "theme";
import { repositoryConfigs } from "utils/prismicPreviews";

interface OwnProps {
  element: React.ReactElement;
}

type GatsbyBrowserProps = OwnProps;

export const wrapRootElement: React.FC<GatsbyBrowserProps> = ({
  element,
}): React.ReactElement => (
  <ThemeProvider theme={theme}>
    <BreakpointsProvider>
      <PrismicPreviewProvider repositoryConfigs={repositoryConfigs}>
        {element}
      </PrismicPreviewProvider>
    </BreakpointsProvider>
  </ThemeProvider>
);
